export const MONTHLY_HOURS_OF_WORK = 173;
const MONTHS_IN_A_YEAR = 12;

export const getAmountInUSD = (currency, amount, countries) => {
  const country = countries.find((country$1) => country$1.currency === currency);
  return amount && country ? amount / country.rate : null;
};

export const getAmountInUSDWithCurrencyRate = (amount, currencyRate) => {
  return amount && currencyRate ? amount / currencyRate : null;
};

export const getAmountInLocalCurrency = (localCurrency, usdAmount, countries) => {
  const country = countries.find((country$1) => country$1.currency === localCurrency);
  return usdAmount && country ? country.rate * usdAmount : null;
};

export const convertValueToHourlyAmount = (amountUnit, amount) => {
  if (typeof amount !== 'number') {
    return null;
  }
  switch (amountUnit) {
    case 'per Hour':
    case 'hourly':
      return amount;
    case 'per Month':
    case 'monthly':
      return amount / MONTHLY_HOURS_OF_WORK;
    case 'per Year':
    case 'yearly': {
      const value = amount / (MONTHLY_HOURS_OF_WORK * MONTHS_IN_A_YEAR);
      return value;
    }
    default:
      throw new Error(`unexpected unit: ${amountUnit}`);
  }
};

export const convertValueToMonthlyAmount = (amountUnit, amount) => {
  if (typeof amount !== 'number') {
    return null;
  }
  switch (amountUnit) {
    case 'per Hour':
    case 'hourly':
      return amount * MONTHLY_HOURS_OF_WORK;
    case 'per Month':
    case 'monthly':
      return amount * 1;
    case 'per Year':
    case 'yearly': {
      const value = amount / (MONTHS_IN_A_YEAR);
      return value;
    }
    default:
      throw new Error(`unexpected unit: ${amountUnit}`);
  }
};

export const convertValueToYearlyAmount = (amountUnit, amount) => {
  if (typeof amount !== 'number') {
    return null;
  }

  switch (amountUnit) {
    case 'per Hour':
    case 'hourly': {
      const value = amount * MONTHLY_HOURS_OF_WORK * MONTHS_IN_A_YEAR;
      return value;
    }
    case 'per Month':
    case 'monthly':
      return amount * MONTHS_IN_A_YEAR;
    case 'per Year':
    case 'yearly':
      return amount;
    default:
      throw new Error(`unexpected unit: ${amountUnit}`);
  }
};

export const formatValueAsCurrency = (amount, currency = "USD") => {
  if (!Number.isFinite(amount)) {
    return 'N/A';
  }

  const dollarCurrencies = ['AUD', 'CAD', 'HKD', 'NZD', 'SGD', 'ZWD', 'BND', 'BBD', 'KYD', 'XCD', 'LRD'];

  try {

    const formatter = new Intl.NumberFormat(navigator.language, {
      style: 'currency',
      currency,
      currencyDisplay: 'narrowSymbol',
      minimumFractionDigits: 0,
      maximumFractionDigits: amount % 1 === 0 ? 0 : 2,
    });

    const parts = formatter.formatToParts(amount);
    let formattedValue = '';

    for (const part of parts) {
      if (part.type === 'currency') {
        if (dollarCurrencies.includes(currency)) {
          formattedValue += `${currency} ${part.value}`;
        } else {
          formattedValue += part.value;
        }
        formattedValue += ' ';
      } else if (part.type !== 'literal') {
        formattedValue += part.value;
      }
    }

    return formattedValue.replace('\u00a0', ' ');
  } catch (error) {
    return `${amount} ${currency}`;
  }
};
